module.exports = __webpack_public_path__ + "img/red-square-table-8.e0fc5d72.png";